import styled from "styled-components";
import { images } from "../../constants";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: nowrap;
  min-height: 100vh;
  color: var(--primary);
  background-color: var(--secondary);
`;

export const ImgCemforpe = styled.img`
  width: 60%;
  border-radius: 1rem;

  @media (max-width: 600px) {
    width: 80%;
  }
`;

export const ContentText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 1rem;
`;

export const Text = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: nowrap;
  text-align: justify;
  font: var(--body);
`;

export const ButtonAcessar = styled.b`
  display: flex;
  font: var(--body);
`;

export const Title = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: nowrap;
  text-align: justify;
  font: var(--title);
`;

export const BoxNames = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  width: 100%;
`;

export const ContentNames = styled.div`
  display: flex;
  flex-direction: row;
  gap: 3rem;
  width: 100%;
  margin-bottom: 3rem;
  
  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

export const TextItem = styled.ul`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: nowrap;
  text-align: justify;
  font-family: var(--familyBody);
  padding: 0 0 0 4rem;
  line-height: 1.3rem;
  font-size: calc(var(--size) * 1.6);
`;

export const Contact = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  text-align: justify;
  line-height: 0.8rem;
  font-family: var(--familyBody);
  font-size: calc(var(--size) * 1.3);
`;

export const Map = styled.iframe`
  width: 100%;
  max-width: 45rem;
  height: 25rem;
  border-radius: 1rem;
  margin: 1rem;
`;

export const Link = styled.div`
  transition: transform 0.3s ease;
  cursor: pointer;

  :hover {
    transform: scale(0.9);
  }
`;

export const BoxCards = styled.div`
  display: flex;
  flex-direction: rows;
  flex-wrap: wrap;
  gap: 2rem;
`;

export const CardName = styled.div`
  display: flex;
  width: 28rem;
  height: 23rem;
  align-items: center;
  flex-direction: column;
  border: solid 0.3rem;
  border-radius: 2rem;
  background-color: var(--softBlue);
  background-image: url(${images.fundobanner});
  border-color: var(--softBlue);
  box-shadow: 0.3rem 0.3rem 0.3rem var(--gray);
`;

export const Photo = styled.img`
  display: flex;
  width: 15rem;
  height: 15rem;
  padding: 0.5rem 0.5rem 0 0.5rem;
  border-radius: 5%; 
`

export const Bio = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: rows;
  width: 100%;
  height: 100%;
  border-radius: 0 0 1.6rem 1.6rem;
  justify-content: center;
  align-items: center;
  background-color: var(--softGray);
  color: var(--primary);
  padding: 0.4rem;  
`